export default "__VITE_ASSET__BE2nzppm__"